export default __webpack_public_path__ + "static/media/product-detail-image-1.94dc2e33.svg";